/* Reviewsectie (vervangt Loox, okt 2026). Canon: docs/apps-vervangen.md
   De eerste reviews staan al in de pagina (Liquid, mv-review-kaart). Komt de sectie in beeld, dan haalt dit
   script de volledige lijst op (JSON in Shopify Files) voor "Meer reviews", sorteren, sterfilter en de pop-up.
   De kaartopmaak hieronder (kaart()) is gelijk aan snippets/mv-review-kaart.liquid: wijzig ze samen. */
(() => {
  if (customElements.get('mv-reviews')) return;

  const VOORLADEN = '600px';
  const SORTERING = {
    featured: () => 0,
    newest: (a, b) => (a.d < b.d ? 1 : a.d > b.d ? -1 : 0),
    highest: (a, b) => b.s - a.s,
    lowest: (a, b) => a.s - b.s,
  };
  const INFO_GEVERIFIEERD = 'This review is from a verified customer who bought this item.';
  const INFO_FOTO = 'This customer received a discount on a future purchase for adding a photo or video to the review.';

  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const datum = (d) => { const [j, m, dag] = d.split('-'); return `${Number(m)}/${Number(dag)}/${j}`; };
  const metMarkering = (r) => (r.h || []).reduce((t, zin) => t.split(esc(zin)).join(`<mark>${esc(zin)}</mark>`), esc(r.t));
  const sterren = (n, maat) => `<span class="mvs mvs--los" style="--mvs-maat: ${maat}px; --mvs-vol: ${n}; --mvs-half: 0;" aria-hidden="true"><span class="mvs__sterren"></span></span>`;

  class MvReviews extends HTMLElement {
    connectedCallback() {
      this.raster = this.querySelector('[data-mvr-raster]');
      this.meerKnop = this.querySelector('[data-mvr-meer]');
      this.pop = this.querySelector('[data-mvr-pop]');
      this.schrijfPop = this.querySelector('[data-mvr-schrijf-pop]');
      // Na versturen laadt Shopify de pagina opnieuw: toon dan meteen de bedankt- of foutmelding.
      if (this.schrijfPop?.querySelector('[data-mvr-schrijf-klaar]')) this.schrijfPop.showModal();
      this.perKeer = Number(this.dataset.perKeer) || 20;
      this.sortering = 'featured';
      this.filter = null;
      this.alle = null;
      this.getoond = this.raster.children.length;

      this.addEventListener('click', (e) => this.klik(e));
      this.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.mvr-kaart')) { e.preventDefault(); this.openPop(e.target); }
        if (e.key === 'Escape') this.sluitPanelen();
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.sluitPanelen(); });
      this.pop.addEventListener('click', (e) => { if (e.target === this.pop) this.pop.close(); });

      this.kaarten = [...this.raster.querySelectorAll('.mvr-kaart')];
      this.bouwKolommen();
      new ResizeObserver(() => this.herschik()).observe(this);
      new IntersectionObserver((items, io) => {
        if (items.some((i) => i.isIntersecting)) { io.disconnect(); this.laad(); }
      }, { rootMargin: VOORLADEN }).observe(this);
    }

    icoon(naam) { return this.querySelector(`template[data-mvr-icoon="${naam}"]`)?.innerHTML || ''; }

    async laad() {
      if (this.alle || this.laden) return this.laden;
      this.laden = fetch(this.dataset.bestand)
        .then((res) => { if (!res.ok) throw new Error(`reviews ${res.status}`); return res.json(); })
        .then((lijst) => {
          this.alle = lijst;
          if (this.getoond < this.perKeer) this.toon(this.perKeer, false);
        })
        .catch((e) => {
          // de reviews in de pagina blijven staan; alleen meer laden, sorteren en filteren werken dan niet
          console.error('[mv-reviews] volledige lijst niet geladen', e);
          this.meerKnop.hidden = true;
        });
      return this.laden;
    }

    lijst() {
      const basis = this.filter ? this.alle.filter((r) => r.s === this.filter) : this.alle;
      return this.sortering === 'featured' ? basis : [...basis].sort(SORTERING[this.sortering]);
    }

    toon(aantal, opnieuw) {
      const lijst = this.lijst();
      const van = opnieuw ? 0 : this.getoond;
      const nieuw = lijst.slice(van, aantal).map((r) => this.kaart(r));
      if (opnieuw) {
        this.kaarten = nieuw;
        this.bouwKolommen();
      } else {
        this.kaarten.push(...nieuw);
        this.plaats(nieuw);
      }
      this.getoond = Math.min(aantal, lijst.length);
      this.meerKnop.hidden = this.getoond >= lijst.length;
    }

    kaart(r) {
      const foto = r.m?.[0];
      const el = document.createElement('article');
      el.className = 'mvr-kaart';
      el.tabIndex = 0;
      el.setAttribute('role', 'button');
      el.dataset.mvrId = r.i;
      el.setAttribute('aria-label', `Review by ${r.n}, ${r.s} out of 5 stars`);
      el.innerHTML = `${foto ? `<div class="mvr-kaart__beeld" style="aspect-ratio: ${foto.w} / ${foto.h};">
          <img src="${foto.u}?width=540" srcset="${foto.u}?width=270 270w, ${foto.u}?width=540 540w, ${foto.u}?width=810 810w"
            sizes="(min-width: 920px) 270px, 50vw" width="${foto.w}" height="${foto.h}" loading="lazy" alt="Customer photo from ${esc(r.n)}">
          ${r.m.length > 1 ? `<span class="mvr-kaart__meer">${this.icoon('fotos')}+${r.m.length - 1}</span>` : ''}</div>` : ''}
        <div class="mvr-kaart__tekst">
          <div class="mvr-kaart__naam">${esc(r.n)}${r.v ? `<span class="mvr-geverifieerd">${this.icoon('geverifieerd')}Verified</span>` : ''}</div>
          <div class="mvr-kaart__datum">${datum(r.d)}</div>
          ${sterren(r.s, 14)}
          <p class="mvr-kaart__inhoud">${metMarkering(r)}</p>
          ${r.y ? `<div class="mvr-kaart__type"><span>Type:</span>${esc(r.y)}</div>` : ''}
        </div>`;
      return el;
    }

    aantalKolommen() {
      return Math.max(1, parseInt(getComputedStyle(this.raster).getPropertyValue('--mvr-kolommen'), 10) || 1);
    }

    // Metselwerk zoals Loox: elke kaart in de op dat moment kortste kolom, zodat de volgorde van links
    // naar rechts leesbaar blijft. Hoogtes kloppen vooraf dankzij aspect-ratio op de foto's.
    bouwKolommen() {
      this.raster.classList.add('is-metselwerk');
      this.kolommen = Array.from({ length: this.aantalKolommen() }, () => {
        const k = document.createElement('div');
        k.className = 'mvr__kolom';
        return k;
      });
      this.raster.replaceChildren(...this.kolommen);
      this.plaats(this.kaarten);
    }

    plaats(kaarten) {
      kaarten.forEach((kaart) => {
        this.kolommen.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a)).append(kaart);
      });
    }

    herschik() {
      if (this.kolommen && this.kolommen.length !== this.aantalKolommen()) this.bouwKolommen();
    }

    reviewVan(kaart) {
      const id = kaart.dataset.mvrId;
      if (this.alle) return this.alle.find((r) => r.i === id);
      return null;
    }

    async klik(e) {
      const open = e.target.closest('[data-mvr-open]');
      if (open) return this.wisselPaneel(open);
      const filter = e.target.closest('[data-mvr-filter]');
      if (filter) return this.zetFilter(Number(filter.dataset.mvrFilter), filter);
      const sorteer = e.target.closest('[data-mvr-sorteer]');
      if (sorteer) return this.zetSortering(sorteer.dataset.mvrSorteer);
      if (e.target.closest('[data-mvr-meer]')) {
        await this.laad();
        return this.alle && this.toon(this.getoond + this.perKeer, false);
      }
      if (e.target.closest('[data-mvr-schrijf]')) return this.schrijfPop.showModal();
      if (e.target.closest('[data-mvr-sluit]')) return e.target.closest('dialog').close();
      const pijl = e.target.closest('[data-mvr-pijl]');
      if (pijl) {
        const strook = this.pop.querySelector('.mvr-pop__strook');
        return strook.scrollBy({ left: Number(pijl.dataset.mvrPijl) * strook.clientWidth, behavior: 'smooth' });
      }
      const kaart = e.target.closest('.mvr-kaart');
      if (kaart) this.openPop(kaart);
    }

    wisselPaneel(knop) {
      const paneel = this.querySelector(`[data-mvr-paneel="${knop.dataset.mvrOpen}"]`);
      const open = paneel.hidden;
      this.sluitPanelen();
      paneel.hidden = !open;
      knop.setAttribute('aria-expanded', String(open));
    }

    sluitPanelen() {
      this.querySelectorAll('[data-mvr-paneel]').forEach((p) => { p.hidden = true; });
      this.querySelectorAll('[data-mvr-open]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
    }

    async zetFilter(ster, knop) {
      await this.laad();
      if (!this.alle) return;
      this.filter = this.filter === ster ? null : ster;
      this.querySelectorAll('[data-mvr-filter]').forEach((k) => k.setAttribute('aria-pressed', String(k === knop && this.filter !== null)));
      this.sluitPanelen();
      this.toon(this.perKeer, true);
    }

    async zetSortering(sortering) {
      await this.laad();
      if (!this.alle) return;
      this.sortering = sortering;
      this.querySelectorAll('[data-mvr-sorteer]').forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.mvrSorteer === sortering)));
      this.sluitPanelen();
      this.toon(this.perKeer, true);
    }

    async openPop(kaart) {
      await this.laad();
      const r = this.reviewVan(kaart);
      if (!r) return;
      const fotos = r.m || [];
      this.pop.querySelector('[data-mvr-pop-beelden]').innerHTML = fotos.length ? `
        <div class="mvr-pop__strook">${fotos.map((f, i) => `<img src="${f.u}?width=1080" width="${f.w}" height="${f.h}" alt="Customer photo ${i + 1} from ${esc(r.n)}" ${i ? 'loading="lazy"' : ''}>`).join('')}</div>
        ${fotos.length > 1 ? `<button type="button" class="mvr-pop__pijl mvr-pop__pijl--terug" data-mvr-pijl="-1" aria-label="Previous photo">${this.icoon('pijl')}</button>
        <button type="button" class="mvr-pop__pijl mvr-pop__pijl--verder" data-mvr-pijl="1" aria-label="Next photo">${this.icoon('pijl')}</button>` : ''}` : '';
      this.pop.querySelector('[data-mvr-pop-tekst]').innerHTML = `
        <div class="mvr-pop__details">
          <div class="mvr-pop__kop">
            <div class="mvr-pop__naam">${esc(r.n)}</div>
            ${r.v ? `<details class="mvr-pop__info"><summary>${this.icoon('geverifieerd')}Verified<span class="mvr-pop__info-i">${this.icoon('info')}</span></summary>
              <p>${INFO_GEVERIFIEERD}${fotos.length ? ` ${INFO_FOTO}` : ''}</p></details>` : ''}
          </div>
          <div class="mvr-pop__regel">${sterren(r.s, 18)}<span class="mvr-pop__datum">${datum(r.d)}</span></div>
        </div>
        <div class="mvr-pop__inhoudvak">
          <p class="mvr-pop__inhoud">${metMarkering(r)}</p>
          ${r.y ? `<div class="mvr-pop__type"><span>Type:</span>${esc(r.y)}</div>` : ''}
        </div>`;
      this.pop.showModal();
    }
  }

  customElements.define('mv-reviews', MvReviews);
})();
